import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


// Save the original console functions for internal use in the LoggingService
(window as any).__originalConsoleLog = console.log.bind(console);
(window as any).__originalConsoleError = console.error.bind(console);
(window as any).__originalConsoleWarn = console.warn.bind(console);

// Diagnostic prefixes that should always pass through console.warn on local dev
const DIAGNOSTIC_PREFIXES = ['[diag]', '[router]', '[adminguard]', '[refreshtokeninterceptor]', '[autheffect]', '[authreducer]', '[socketservice]'];

// Override console.log, console.error, console.warn
console.log = function(...args: any[]) {
  // Suppressed — use LoggingService instead
};

console.error = function(...args: any[]) {
  (window as any).__originalConsoleError.apply(console, args);
};

console.warn = function(...args: any[]) {
  const msg = args[0]?.toString?.() ?? '';
  if (!environment.production && !environment.stage) {
    const lower = msg.toLowerCase();
    if (!lower.includes('warning') && !DIAGNOSTIC_PREFIXES.some(p => lower.includes(p))) return;
  }

  (window as any).__originalConsoleWarn.apply(console, args);
};


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
